import { GetOauthUrl } from '@/api/tutoringAgency';

/**
 * 检查用户是否已登录
 * @param {Object} store - Vuex store实例
 * @returns {Boolean} 是否已登录
 */
export function checkLoginStatus(store) {
  // 通过判断openid是否全局缓存来判断是否已登录
  const openid = localStorage.getItem('openid');
  return store.state.isLoggedIn && store.state.userInfo && openid;
}

/**
 * 获取微信授权地址并跳转
 * @param {String} currentUrl - 当前页面地址（用于授权后返回）
 */
export async function redirectToWechatAuth(currentUrl) {
  try {
    // 构建完整的回调地址，包含redirect参数
    const callbackUrl = `${window.location.origin}/login?redirect=${encodeURIComponent(currentUrl)}`;
    
    // 调用接口获取授权地址
    const response = await GetOauthUrl(callbackUrl);
    console.log("调用接口获取授权地址:", response);
    // 跳转到微信授权页面
    window.location.href = response.data.url || response.data;
    
  } catch (error) {
    console.error('获取微信授权地址失败:', error);
    throw new Error('获取授权地址失败');
  }
}

/**
 * 处理需要登录的页面访问
 * @param {Object} store - Vuex store实例
 * @param {String} currentUrl - 当前页面地址
 */
export async function handleAuthRequired(store, currentUrl) {
  if (!checkLoginStatus(store)) {
    // 未登录，跳转到微信授权
    await redirectToWechatAuth(currentUrl);
    return false;
  }
  return true;
} 